<!-- Banner Section -->
<section class="hero-section bg-image">
  <div class="hero-content">
    <h2 class="h2-bg">Find Your <span class="fw-bold">Perfect Property</span></h2>
  </div>

  <div class="search-bar-container">
    <!-- Tabs -->
    <div class="property-type-tabs d-flex justify-content-center mb-3">
      <a class="property-tab" href="javascript:void(0)" (click)="onSellProperty()">Sell Property</a>
      <a class="property-tab" [ngClass]="selling_type == 'buy' ? 'active-tab' : ''"
         href="javascript:void(0)" (click)="changePropertyType('buy')">Buy Property</a>
      <a class="property-tab" [ngClass]="selling_type == 'rent' ? 'active-tab' : ''"
         href="javascript:void(0)" (click)="changePropertyType('rent')">Rent Property</a>
      <a class="property-tab" [ngClass]="selling_type == 'offplan' ? 'active-tab' : ''"
         href="javascript:void(0)" (click)="changePropertyType('offplan')">Off Plan</a>
    </div>

    <!-- Search Form -->
    <form class="search-form">
      <!-- Location -->
      <div class="form-field location-field">
        <tag-input class="custom-tag-input"
          [ngModel]='tagValues'
          [identifyBy]="'value'"
          [displayBy]="'label'"
          [onlyFromAutocomplete]="true"
          [ngModelOptions]="{standalone: true}"
          (onAdd)="onAdded($event)"
          (onRemove)="onDelete($event)"
          placeholder="Location"
          secondaryPlaceholder="Location">
          <tag-input-dropdown
            [showDropdownIfEmpty]="true"
            [autocompleteObservable]="requestAutocompleteItems"
            [identifyBy]="'value'"
            [displayBy]="'label'">
          </tag-input-dropdown>
        </tag-input>
      </div>

      <!-- Property Type -->
      <div class="form-field">
        <div class="custom-dropdown" (click)="toggleDropdown()" [class.open]="isDropdownOpen">
          <div class="selected-option">
            {{ selectedOption || 'Property Type' }}
            <i class="fas fa-chevron-down dropdown-arrow"></i>
          </div>
          <div class="options" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
            <div *ngFor="let option of propertyTypes"
                 (click)="selectOption(option)"
                 [ngClass]="selectedOption == option ? 'selected-option-dropdown' : ''">
              {{ option }}
            </div>
          </div>
        </div>
      </div>

      <!-- Bedrooms -->
      <div class="form-field">
        <div class="custom-dropdown" (click)="bedroomtoggleDropdown()" [class.open]="isBedroomDropdownOpen">
          <div class="selected-option">
            {{ bedroomselectedOption ? bedroomselectedOption + (bedroomselectedOption == '1' ? ' Bed' : ' Beds') : 'Bedrooms' }}
            <i class="fas fa-chevron-down dropdown-arrow"></i>
          </div>
          <div class="options" *ngIf="isBedroomDropdownOpen" (click)="$event.stopPropagation()">
            <div *ngFor="let option of bedroomnumber"
                 (click)="bedrooomselectOption(option)"
                 [ngClass]="bedroomselectedOption == option ? 'selected-option-dropdown' : ''">
              {{ option }}
            </div>
          </div>
        </div>
      </div>

      <!-- Price -->
      <div class="form-field">
        <div class="custom-dropdown" (click)="budgetToggleDropdown()" [class.open]="isBudgetDropdownOpen">
          <div class="selected-option">
            {{ (minPrice || maxPrice) ? minPrice + ' - ' + maxPrice : 'Price Limit' }}
            <i class="fas fa-chevron-down dropdown-arrow"></i>
          </div>
          <div class="options p-3" *ngIf="isBudgetDropdownOpen" (click)="$event.stopPropagation()">
            <div class="d-flex align-items-center mb-3">
              <!-- Min -->
              <select class="form-select me-2" [(ngModel)]="minPrice" (click)="$event.stopPropagation()">
                <option value="">Min</option>
                <option *ngFor="let price of priceOptions" [value]="price">{{ price }}</option>
              </select>
              <span class="mx-2">-</span>
              <!-- Max -->
              <select class="form-select ms-2" [(ngModel)]="maxPrice" (click)="$event.stopPropagation()">
                <option value="">Max</option>
                <option *ngFor="let price of priceOptions" [value]="price">{{ price }}</option>
              </select>
            </div>
            <div class="text-end">
              <button class="btn btn-link p-0 text-danger" (click)="clearAll()">Clear All</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Filter Icon -->
      <!-- <div class="filter-icon-container">
        <i class="fas fa-sliders-h filter-icon-standalone"></i>
      </div> -->

      <!-- Search Button -->
      <button type="button" class="search-button" (click)="onSearch()">
        <i class="fas fa-search"></i>
        SEARCH
      </button>
    </form>
  </div>
</section>




<section class="featured-properties-section bg-light pt-4 pb-4" style="margin-top: 150px;">
  <div class="container-xl">
    <div class="section-header">
      <h2>Featured Developers</h2>
    </div>

    <swiper [slidesPerView]="4" [spaceBetween]="30" [config]="swiperOp" (slideChange)="onSlideChange()">
      <ng-template swiperSlide *ngFor="let s of developerData">
        <div class="property-card developer-card">
          <div class="card-image-container">
            <img 
  [src]="shared.getImageURL(s.developer_logo) || shared.getDeveloperImageURL(s.developer_logo)" 
  alt="Developer Logo" 
  class="property-image"
/>
          </div>
          <div class="card-details text-center">
            <h3>{{ s.developer_name }}</h3>
            <button class="btn btn-theme mt-2" (click)="redirectProperty(s)">
              View Properties
            </button>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</section>


<app-featured-properties></app-featured-properties>
<!-- <div style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100%;">
    <iframe width="20%" height="250px" src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0" frameborder="0" allowfullscreen></iframe>
</div> -->
  
<!-- <section class="ftco-section">
    <div class="container-xl">
        <div class="row justify-content-center">
            <div class="col-md-8 heading-section text-center" data-aos="fade-up" data-aos-duration="1000">
                <h2 class="mb-3">
                    PodCast
                </h2>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <swiper [slidesPerView]="4" [config]="swiperOp" [spaceBetween]="50" (slideChange)="onSlideChange()">
            <ng-template swiperSlide *ngFor="let podcast of podcasts">
                <iframe [src]="podcast.safeIframeUrl" alt="Slide Image" class="swiper-img">
                </iframe>
        
        <h3 class="mt-1 slider-city-name">{{ podcast.truncatedName }}</h3>
        </ng-template>
        </swiper>
    </div>
</div>
</div>
</section> -->

<!-- Catagories and Places -->
<section class="featured-properties-section ">
  <div class="section-header">
    <h2>Explore Our Categories</h2>
    <p>Find the right property type that matches your lifestyle and needs.</p>
  </div>

  <div class="properties-grid">
    <!-- Apartment -->
    <div class="property-card category-card">
      <div class="card-image-container category-icon">
        <i class="flaticon-apartment"></i>
      </div>
      <div class="card-details text-center">
        <h3>Apartment</h3>
        <a href="properties/type/apartment" class="btn btn-theme mt-2">Explore</a>
      </div>
    </div>

    <!-- Townhouse -->
    <div class="property-card category-card">
      <div class="card-image-container category-icon">
        <i class="flaticon-architect"></i>
      </div>
      <div class="card-details text-center">
        <h3>Townhouse</h3>
        <a href="properties/type/townhouse" class="btn btn-theme mt-2">Explore</a>
      </div>
    </div>

    <!-- Villa -->
    <div class="property-card category-card">
      <div class="card-image-container category-icon">
        <i class="flaticon-house"></i>
      </div>
      <div class="card-details text-center">
        <h3>Villa</h3>
        <a href="properties/type/villa" class="btn btn-theme mt-2">Explore</a>
      </div>
    </div>

    <!-- Off Plan -->
    <div class="property-card category-card">
      <div class="card-image-container category-icon">
        <i class="flaticon-apartment"></i>
      </div>
      <div class="card-details text-center">
        <h3>Off Plan</h3>
        <a href="properties/type/offplan" class="btn btn-theme mt-2">Explore</a>
      </div>
    </div>
  </div>
</section>



<!-- <section class="ftco-section  bg-light">
    <div class="container-xl">
        <div class="row justify-content-center">
            <div class="col-md-8 heading-section text-center" data-aos="fade-up" data-aos-duration="1000">
                <h2 class="mb-3">
                    Virtual Tour
                </h2>
            </div>
        </div>
        <div class="row">
            <app-direkt-virtual-tour></app-direkt-virtual-tour>
        </div>
    </div>
</section> -->

<section class="featured-properties-section bg-light pt-4 pb-4">
    <div class="section-header text-center">
      <h2>Explore Off-plan Properties</h2>
    </div>

    <div class="row">
      <app-new-featured-properties [property_type_id]="1"></app-new-featured-properties>
    </div>
    <div class="section-header text-center mt-4">
      <h2>
                    Newly Added Properties
                </h2>
          
        </div>
        <div class="row">
            <app-new-featured-properties [pClass]="'bg-white'" [property_type_id]="1"></app-new-featured-properties>
            <!-- <app-new-featured-properties [property_type_id]="3"></app-new-featured-properties>
            <app-new-featured-properties [property_type_id]="2"></app-new-featured-properties> -->
        </div>
   
</section>


<!-- <section class="ftco-section">
    <div class="container">
        <div class="row">
            <div class="col-md-3" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
       
        <div class="img">
            <img src="../../assets/images/image_9.jpg" class="image" alt="">
        </div>
    </div>
    <div class="col-md-9">
        <div class="row">
            <div class="col-3">
                <p></p>
            </div>
            <div class="col-9" data-aos="fade-up" data-aos-duration="1000">
                <h4 style="color: orangered;">
                    OUR SPECIALTY
                </h4>
            </div>
            
        </div>
        <div class="row">
            <div class="col-3">
                <p></p>
            </div>
           
            <div class="col-9">
                <h1>What's so Special About <br> Shambhavi Technovation</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <p></p>
            </div>
           
            <div class="col-6">
                <p>Bring to the table win-win survival strategies to ensure dotted proactive domination. At the end of the day, going forward, a new normal that has evolved</p>
            </div>
            
        </div>
        

    </div>
</div>
    </div>
    

</section> -->

<section class="ftco-section review-section">
  <div class="container mb-5">
    <div class="row justify-content-center">
      <div class="col-md-8 heading-section text-center" data-aos="fade-up" data-aos-duration="1000">
        <h2 class="mb-3">
          Our Review: <span class="main-text-color">‘Direktly’</span>
        </h2>
        <!-- <p class="review-subtitle">What our clients say about us</p> -->
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <swiper [slidesPerView]="3" [spaceBetween]="30" [config]="swiperReview" (slideChange)="onSlideChange()">
          <ng-template swiperSlide *ngFor="let s of reviewData">
            <div class="review-card">
              <div class="review-image">
                <img [src]="shared.getImageURL(s.review_image)" alt="Review Image" />
              </div>
              <div class="review-details">
                <p class="review-text">
                  <i>
                    <sup><i class="fas fa-quote-left me-2"></i></sup>
                    {{ s.review_short }}
                  </i>
                </p>
                <button class="btn btn-theme mt-3" (click)="redirectReview(s.review_id)">
                  View More
                </button>
              </div>
            </div>
          </ng-template>
        </swiper>
      </div>
    </div>
  </div>
</section>

<section class="ftco-section bg-light">
  <div class="container mb-3">
    <div class="row justify-content-center">
      <div class="col-md-8 heading-section text-center" data-aos="fade-up" data-aos-duration="1000">
        <h2 class="mb-3">Explore Our Places</h2>
      </div>
    </div>

    <!-- City Grid -->
    <div class="city-grid">
      <div class="city-card city-card-wide" *ngFor="let s of sliderItems; let i = index">
        <a [href]="getCityUrl(s.city)">
          <img [src]="s.image" [alt]="s.city" class="city-image" />
          <div class="city-info">
            <h4 class="city-name">{{ s.city }}</h4>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

<section class="featured-properties-section">
    <div class="section-header">
        <h2>Talk Stream</h2>
        <!-- <p>Strong and flexible layouts designed with modern style and comfort in mind.</p> -->
    </div>

    <swiper [slidesPerView]="4" [spaceBetween]="30" [config]="swiperOp" (slideChange)="onSlideChange()"
        class="properties-grid">
        
        <ng-template swiperSlide *ngFor="let podcast of podcasts">
            <div class="property-card">
                <div class="card-image-container">
                    <iframe [src]="podcast.safeIframeUrl" class="property-image" frameborder="0"></iframe>
                </div>
                <div class="card-details">
                    <h3>{{ podcast.truncatedName }}</h3>
                    <p class="location-text">Podcast Episode</p>
                </div>
            </div>
        </ng-template>
    </swiper>
</section>

<!-- Tag  -->
<section class="ftco-intro ftco-no-pt ftco-no-pb img" style="background-image: url(./../assets/images/bg_4.jpg);">
    <div class="overlay"></div>
    <div class="container-xl py-3">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-xl-8">
                <div class="row">
                    <div class="col-md-8 d-flex align-items-center ">
                        <div>
                            <h1 class="mb-0 fs-18">
                                Assisted plans for developers<br /> Get in touch to sell/rent your project.
                            </h1>
                            <!-- <p>Find Best Place For Leaving</p> -->
                        </div>
                    </div>
                    <div class="col-md-4 d-flex align-items-center">
                        <p class="mb-0"><a class="btn btn-white py-2 px-3" (click)="onAssistedPlan()">Click here</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- <section class="ftco mt-5">
    <div class="container mb-5">
        <div class="row text-center">
            <h2 class="creative-text">
                We are coming soon with our app on Apple App Store and Google Play Store!<i class="fas fa-rocket"></i>
            </h2>
        </div>
    </div>
</section> -->

<div class="modal fade" *ngIf="contact_type == '1'" id="propertyModalCenter" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content ">
            <div class="modal-header mt-3">
                <h5 class="modal-title" id="exampleModalLongTitle">
                    Do you own multiple properties?
                </h5>
                <button type="button" class="btn btn-primary close mb-1" data-dismiss="modal"
                    (click)="closeModal('multiple_properties')">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">
                <app-contact-us-model [showContactInfo]="false" [contact_type]="1"></app-contact-us-model>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" *ngIf="contact_type == '2'" id="propertyuaeModalCenter" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content ">
            <div class="modal-header mt-3">
                <h5 class="modal-title" id="exampleModalLongTitle">
                    Property owners outside UAE
                </h5>
                <button type="button" class="btn btn-primary close mb-1" data-dismiss="modal"
                    (click)="closeModal('owner_outside_uae')">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">
                <app-contact-us-model [showContactInfo]="false" [contact_type]="2"></app-contact-us-model>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="devloperModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered total_area modal-dialog modal-lg" role="document">
        <div class="modal-content ">
            <div class="modal-header mt-3">
                <h5 class="modal-title" id="exampleModalLongTitle">
                    Assisted Plans For Developers
                </h5>
                <button type="button" class="btn btn-close  mb-1" (click)="closeAssistedPlan()">
                    <span>&times;</span>
                    <span></span>
                </button>
            </div>
            <div class="modal-body">
                <div *ngIf="!isSubmitted; else successMessageTemplate">
                    <form id="devloperForm" [formGroup]="devloperForm" name="devloperForm" class="devloperForm"
                        method="POST">
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Name:</label>
                            </div>
                            <div class="col-9">
                                <input type="text" class="form-control" formControlName="name">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Email:</label>
                            </div>
                            <div class="col-9">
                                <input type="email" class="form-control" formControlName="email">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Mobile:</label>
                            </div>
                            <div class="col-9">
                                <input type="text" class="form-control" formControlName="mobile">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Project Name:</label>
                            </div>
                            <div class="col-9">
                                <input type="text" class="form-control" formControlName="project_name">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Devloper Name:</label>
                            </div>
                            <div class="col-9">
                                <input type="text" class="form-control" formControlName="devloper_name">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-3">
                                <label for="nameInput" class="form-label">Emirate:</label>
                            </div>
                            <div class="col-9">
                                <select class="form-control" formControlName="emirates">
                                    <option>Please select</option>
                                    <option *ngFor="let e of emirates" [value]="e.id + '_' +e.city">{{e.city}}</option>
                                </select>
                            </div>
                        </div>
                        <!-- Display success message if the form is submitted successfully -->
                        <div *ngIf="isSubmitted && message" class="alert alert-success mt-3">
                            {{ message }}
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" (click)="onDone()">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <ng-template #successMessageTemplate>
            <!-- Display the success message when the form is submitted -->
            <div class="alert alert-success mt-3">
                {{ message }}
            </div>
        </ng-template>
    </div>
</div>

<div id="popoverPriceMainDiv">
    <div id="popoverPriceMainDiv1">
    </div>
    <div id="popoverPriceMainDiv2">
    </div>
    <div id="popoverPriceMainDiv3">
    </div>
</div>


<!-- Modal -->
<!-- <div class="modal fade" id="pageLoadeModal" tabindex="-1">
    <div class="modal-dialog ">
        <div class="modal-content modal-box">
            <div class="modal-header header">
                <h5 class="modal-title title" id="pageLoadeModalLabel">
                    Special Offer
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="offer-content">
                    <i class="fas fa-tags fa-2x mb-3"></i>
                    <h1 class="promotion-text">
                        Get <span class="text-offer">90%</span> off now!
                    </h1>
                    <h5 class="text-subscribe">
                        Subscribe and save big.
                    </h5>
                </div>
                <div class="text-center mt-3">
                    <a href="subscription-owner-plan" class="btn btn-primary btn-subscribe">Subscribe now</a>
                </div>
            </div>            
        </div>
    </div>
</div> -->

<!-- <div class="lightbox" id="lightbox">
    <span class="close">&times;</span>
    <img class="lightbox-content" id="lightbox-image" src="https://www.sobharealty.com/media/e0hhushu/banner-1920x944.jpg?width=1920&height=944&v=1db4d3dd81a2ee0">
    <div class="caption" id="lightbox-caption">
        Discover Skyvue Solair: Taking Opulence to the Next Level
    </div>
    <a href="brochure.pdf" class="download-btn" download>Download Brochure</a>
</div> -->

